import c_7 from "../../assets/audio-screen/unit7/c_7.mp3"
import c_7_1 from "../../assets/audio-screen/unit7/c_7_1.mp3"


export const audio7 = [
   {
    'text':'Lan: Chào bạn, hôm nay bạn có khỏe không?\nFarid: Tớ khỏe, cảm ơn bạn, xin lỗi bạn sinh năm nào ấy nhỉ?\nLan: Mình sinh ngày 23 tháng 8 năm 1994, thế còn bạn?\nFarid: Mình à. Ừm. Mình sinh ngày 15 tháng 08 năm 1990.\nLan: Ôi vậy ạ. Thế thì mình gọi bạn là anh nhé vì hơn tuổi minh.\nFarid: Vậy cũng được.\nLan: Bây giờ anh Farid đang sống ở đâu ạ?\nFarid: Anh đang sống ở thàmh Hà Nội - Việ Nam, còn em?\nLan: Em cũng vậy ạ.\n',
    'audio': c_7,
  },

];

export const audio7_1 = [
    {
     'text':'Mary: Chào cô giáo.\nMs Hoa: Chào chị. Kia là ai?\nMary: Đây là con gái của tôi, tên cháu là Sarah. Sarah. Chào cô giáo đi con.\nSarah: Con chào cô ạ.\nMs Hoa: Cô chào con. Rất vui được gặp con, năm nay con bao nhiêu tuổi?\nSarah: Con 8 tuổi ạ.\nMary: Cháu được sinh vào ngày 5 tháng 9 năm 2000 cô giáo ạ.\nMs Hoa: Con được sinh ra ở đâu?\nSarah: Con được  sinh ra ở thành phố Connecticut của nước Mỹ ạ.\nMs Hoa: Cô hiểu rồi, thế chị đăng ký ghi số đện thoại và địa chỉ để chúng tôi tiện liên lạc và thông báo cho hiệu trưởng trưởng  ạ.\nMary: Cảm ơn cô giáo. Số điện thoại của tôi là 09887780 hiện nay, chúng tôi đang sống tại  Số 03 Đường Paster Quận.\nMs Hoa: Cảm ơn chị và Sarah.\nMary: Chị khách sáo không cógi ạ.\n',
     'audio': c_7_1,
   },
 
 ];